/**
 * =========================================================================================
 * ATS - Global Search
 * =========================================================================================
 *
 **/

import React, {useCallback, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import useSocket from '../../../hooks/useSocket';
import {getLabelValue} from "ubs-framework/v2/common/function";
import {LIMIT} from "ubs-framework/v2/common/constant";
import {sendData} from '../../../../../store/actions';
import UEmployeeInfo from '../../../../../common/components/UEmployeeInfo';

// Framework Components
import UCommandPalette from 'ubs-framework/v2/UCommandPalette';
import UCommandPaletteTrigger from 'ubs-framework/v2/UCommandPalette/trigger';
import useHotKey from 'ubs-framework/v2/hooks/useHotKey';
import usePlan from '../../../hooks/usePlan';
import {PLAN} from 'ubs-framework/v2/common/constant';

const GlobalSearch = ({open, closeSidebar}) => {
    const __plan = usePlan();
    const history = useHistory();
    const _S_ID = useSelector(e => e.common.socketId);
    const [candidateListOption, setCandidateListOption] = useState([]);
    const [jobListOption, setJobListOption] = useState([]);

    const _ORG_ID = useSelector(e => e.common.orgId);
    const _PLAN = useSelector(e => e?.common?.planAccess);
    const _UAC_J = useSelector(e => e?.ats?.uac?.jobs?.modules);
    const _AS = useSelector(e => e?.ats?.uac?.settings?.modules);
    const _UAC_C = useSelector(e => e?.ats?.uac?.candidates?.modules);
    const _UAC_R = useSelector(e => e?.ats?.uac?.requisition?.modules);
    const _UAC_RM = useSelector(e => e?.ats?.uac?.reminder?.modules);
    const _UAC_I = useSelector(e => e?.ats?.uac?.interview?.modules);
    const _UAC_E = useSelector(e => e?.ats?.uac?.employee?.modules);
    const _UAC_PB = useSelector(e => e?.ats?.uac?.preBoarding?.modules);
    const _UAC_RPT = useSelector(e => e?.ats?.uac?.report?.modules);
    const _UAC_RF = useSelector(e => e?.ats?.uac?.referral?.modules);
    const _IA = useSelector(e => e?.common?.isAdmin);
    const _DRL = useSelector(e => getLabelValue(e.ats?.disqualifyReasonList));

    const P_S = useCallback((module, type = 'read') => _AS?.[module]?.action?.[type]?.value, [_AS]);

    /** Candidates details page tab uac object **/

    const P_DT = useSelector(e => ({
        details: e?.ats?.uac?.candidates?.modules?.detail?.action?.read?.value,
        interviews: e?.ats?.uac?.interview?.modules?.interview?.action?.read?.value,
        evaluation: e?.ats?.uac?.candidates?.modules?.evaluation?.action?.read?.value,
        conversation: e?.ats?.uac?.candidates?.modules?.candidates?.action?.comment?.value,
        files: e?.ats?.uac?.candidates?.modules?.file?.action?.read?.value,
        'internal-note': e?.ats?.uac?.candidates?.modules?.internalNotes?.action?.read?.value,
        activity: e?.ats?.uac?.candidates?.modules?.activity?.action?.read?.value,
    }));

    /** jobs details page tab uac object **/
    const P_JDT = useSelector(e => ({
        summary: e?.ats?.uac?.jobs?.modules?.summary?.action?.read?.value,
        jobDetails: e?.ats?.uac?.jobs?.modules?.jobDetail?.action?.read?.value,
        candidates: e?.ats?.uac?.candidates?.modules?.candidates?.action?.read?.value,
        interview: e?.ats?.uac?.interview?.modules?.interview?.action?.read?.value,
        files: e?.ats?.uac?.jobs?.modules?.file?.action?.read?.value,
        report: e?.ats?.uac?.jobs?.modules?.report?.action?.read?.value,
        activity: e?.ats?.uac?.jobs?.modules?.activity?.action?.read?.value,
    }));

    const [allRoutes, setAllRoutes] = useState([
        { name: 'dashboard', route: `dashboard`, isShow: true, isAccess: true },

        /** Jobs */
        { name: 'jobs', route: `jobs`, isShow: true, isAccess: _UAC_J?.jobs?.action?.read?.value },
        { name: 'new jobs / jobs', route: 'jobs/add', isAccess: _UAC_J?.jobs?.action?.create?.value },

        { name: 'candidates', route: `candidates/list`, isShow: true, isAccess: _UAC_C?.candidates?.action?.read?.value },
        { name: 'candidates / Remark candidates', route: `candidates/blocked-candidates`, isShow: true, isAccess: _UAC_C?.remarkCandidate?.action?.read?.value },
        { name: 'candidates / Share Candidates', route: `candidates/shared-candidates`, isShow: true, isAccess: _UAC_C?.sharedCandidate?.action?.read?.value },
        { name: 'candidates / verification Candidates', route: `candidates/verification-candidates`, isShow: true, isAccess: _UAC_C?.verificationCandidate?.action?.read?.value },
        { name: 'reminder', route: `reminder`, isShow: true, isAccess: __plan(PLAN.reminder) && _UAC_RM?.reminder?.action?.read?.value },
        { name: 'interviews', route: `interviews`, isShow: true, isAccess: __plan(PLAN.interview) && _UAC_I?.interview?.action?.read?.value },

        { name: 'requisitions', route: `requisitions`, isAccess: __plan(PLAN.requisitions) && _UAC_R?.requisition?.action?.read?.value },
        { name: 'new requisitions / requisitions', route: 'requisitions/add', isAccess: __plan(PLAN.requisitions) && _UAC_R?.requisition?.action?.create?.value },

        { name: 'employee list', route: `employee-list`, isAccess: !_PLAN?.hrms?.default?.access && _UAC_E?.employee?.action?.create?.value },

        {name: 'referral', route: `referral`, isAccess: __plan(PLAN.referrals) && _UAC_RF?.referral?.action?.read?.value},

        /** preboarding*/
        { name: 'Preboarding / Kick-off ', route: `preboarding/kickoff`, isAccess:  __plan(PLAN?.preBoarding) && _UAC_PB?.preBoarding?.action?.read?.value },
        { name: 'Preboarding / Information Gathering ', route: `preboarding/information-gathering`, isAccess:  __plan(PLAN?.preBoarding) && _UAC_PB?.preBoarding?.action?.read?.value },
        { name: 'Preboarding / Verify Information', route: `preboarding/verify-information`, isAccess:  __plan(PLAN?.preBoarding) && _UAC_PB?.preBoarding?.action?.read?.value },
        { name: 'Preboarding / Release Offer ', route: `preboarding/release-offer`, isAccess:  __plan(PLAN?.preBoarding) && _UAC_PB?.preBoarding?.action?.read?.value },
        { name: 'Preboarding / Offer Acceptance', route: `preboarding/offer-acceptance`, isAccess:  __plan(PLAN?.preBoarding) && _UAC_PB?.preBoarding?.action?.read?.value },
        { name: 'Preboarding / Hired ', route: `preboarding/hired`, isAccess:  __plan(PLAN?.preBoarding) && _UAC_PB?.preBoarding?.action?.read?.value },
        { name: 'Preboarding / offer letter approvals ', route: `preboarding/offer-letter-approvals`, isAccess: __plan(PLAN?.preBoarding) && _UAC_PB?.offerApproval?.action?.read?.value },
        { name: 'Preboarding / Information Fields', route: `preboarding/information-fields`, isAccess: __plan(PLAN?.preBoarding) && _UAC_PB?.preBoardingFieldTemplates?.action?.read?.value },

        /** Settings */
        { name: 'settings / Company Settings', route: 'settings/company-setting', isAccess:  P_S('companySetting') },
        { name: 'settings / Email Configure', route: 'settings/email-configure', isAccess:  P_S('companySetting') },
        { name: 'settings / notification', route: 'settings/notification', isAccess: true },
        { name: 'settings / WhatsApp Notifications', route: 'settings/whatsapp-notification', isAccess: (P_S("whatsappNotification") && __plan(PLAN.whatsappIntegration)) },
        { name: 'settings / integration', route: 'settings/integration', isAccess: (__plan([PLAN?.interview, PLAN?.googleMeetIntegration]) || __plan([PLAN?.interview, PLAN?.zoomIntegration]) || __plan([PLAN?.interview, PLAN?.teamsIntegration])) && P_S('integration') },
        { name: 'settings / audit logs', route: 'settings/audit-logs', isAccess: true },
        { name: 'settings / access level', route: 'settings/access-level', isAccess: P_S('accessLevel') },
        { name: 'new access level / access level / settings', route: 'settings/access-level/add', isAccess: P_S('accessLevel','create') },
        { name: 'settings / disqualify reasons', route: 'settings/disqualify-reasons', isAccess: P_S('disqualifiedReason') },
        { name: 'new disqualify reasons / disqualify reasons / settings', route: 'settings/disqualify-reasons/add', isAccess: P_S('disqualifiedReason','create') },
        { name: 'settings / tags and sources', route: 'settings/tags-and-sources', isAccess: P_S('tagsSource') },
        { name: 'settings / Job Detail and Company Perk', route: 'settings/job-perk', isAccess: P_S('jobDescriptionCompanyPerks')},
        { name: 'settings / Pipeline Templates', route: 'settings/pipeline-templates', isAccess: P_S('pipelineTemplate') },
        { name: 'settings / interview form Templates', route: 'settings/interview-form-templates', isAccess: true },
        { name: 'settings / Custom Fields', route: 'settings/custom-fields', isAccess: P_S('customField') },
        { name: 'settings / Question Bank', route: 'settings/question-bank', isAccess:  P_S('questionBank') },
        { name: 'settings / Duplicate Handling', route: 'settings/duplicate-handling', isAccess: P_S('duplicateHandling') },
        { name: 'settings / Email Templates', route: 'settings/email-templates', isAccess: P_S('emailTemplate') },
        { name: 'settings / Evaluation Forms', route: 'settings/evaluation-forms', isAccess: P_S('evaluationForm') },
        { name: 'settings / Questionnaires', route: 'settings/questionnaires', isAccess: P_S('questionnaires') },
        { name: 'settings / Verification Template', route: 'settings/verification-template', isAccess: P_S('verificationTemplate') },
        { name: 'settings / Screening Questions', route: 'settings/screening-questions', isAccess: P_S('screeningQuestions') },
        // { name: 'settings / Event Questions', route: 'settings/event-questions', isAccess: P_S('eventQuestions') },
        { name: 'settings / Job Templates', route: 'settings/job-templates', isAccess: P_S('jobTemplate') },
        { name: 'settings / Job ID', route: 'settings/job-id', isAccess: P_S('jobId') },
        { name: 'settings / Candidate ID', route: 'settings/candidate-id', isAccess: P_S('candidateId') },
        { name: 'new job templates / Job Templates / settings', route: 'settings/job-templates/add', isAccess: P_S('jobTemplate', 'create') },
        { name: 'settings / Archive Job/Candidate', route: 'settings/archive-job-candidate', isAccess: P_S('archiveJobEmployee') },
        { name: 'settings / job title', route: 'settings/job-title', isAccess: P_S('jobTitle') },
        { name: 'settings / Requisitions Setting / Requisition Fields', route: 'settings/requisitions-setting/requisition-fields', isAccess: (P_S('requisitionSettings')) },
        { name: 'settings / Offer letter Templates', route: 'settings/preboarding-settings/offer-templates', isAccess: __plan(PLAN?.preBoarding) && P_S('preBoardingTemplates') },
        { name: 'settings / Offer Information Field', route: 'settings/preboarding-settings/information-fields', isAccess: __plan(PLAN?.preBoarding) && P_S("preBoardingFieldTemplates") },
        { name: 'settings / Preboarding Documents', route: 'settings/preboarding-settings/documents', isAccess: __plan(PLAN?.preBoarding) && P_S('preBoardingDocuments') },
        { name: 'settings / Preboarding Signature', route: 'settings/preboarding-settings/signature-settings', isAccess:  __plan(PLAN?.preBoarding) && P_S('preBoardingSignature') },
        { name: 'settings / Requisition Policy', route: 'settings/requisitions-setting/requisition-policy', isAccess: P_S('requisitionSettings') },
        { name: 'settings / Org Structure / bands', route: 'settings/org-structure/bands', isAccess: P_S('bands') },
        { name: 'settings / Org Structure / grade', route: 'settings/org-structure/grade', isAccess: P_S('grade') },
        { name: 'settings / interview type', route: 'settings/interview-type', isAccess: __plan(PLAN.interview) && P_S('interviewType') },
        { name: 'settings / job type', route: 'settings/job-type', isAccess: P_S('jobType') },
        { name: 'settings / experience level', route: 'settings/experience-level', isAccess: P_S('experienceLevel') },
        { name: 'settings / department', route: 'settings/department', isAccess: P_S('department') },
        { name: 'settings / location', route: 'settings/location', isAccess: P_S('location') },
        { name: 'settings / skill', route: 'settings/skill', isAccess: P_S('skill') },
        { name: 'settings / degree', route: 'settings/degree', isAccess: P_S('degree') },
        { name: 'settings / Reason For Job Change', route: 'settings/reason-for-job-change', isAccess: P_S('reasonForJobChange') },
        { name: 'settings / Reject Reason', route: 'settings/reject-reason', isAccess: P_S('rejectReason') },

        /** Reports */
        { name: 'Reports', route: `reports`, isShow: true, isAccess: _UAC_RPT?.report?.action?.read?.value },
        { name: 'Reports / Job wise candidate report', route: `reports/job-wise-candidate-report`, isShow: true, isAccess: _UAC_RPT?.report?.action?.read?.value },
        { name: 'Reports / Recruiter wise candidate report', route: `reports/recruiter-wise-candidate-report`, isShow: true, isAccess: _UAC_RPT?.report?.action?.read?.value },
        { name: 'Reports / Stage wise candidate report', route: `reports/stage-wise-candidate-report`, isShow: true, isAccess: _UAC_RPT?.report?.action?.read?.value },
        { name: 'Reports / Disqualify Candidate report', route: `reports/disqualify-candidate-report`, isShow: true, isAccess: _UAC_RPT?.report?.action?.read?.value },
        { name: 'Reports / Source Wise Candidate report', route: `reports/source-wise-candidate-report`, isShow: true, isAccess: _UAC_RPT?.report?.action?.read?.value },
        { name: 'Reports / All jobs hiring status report', route: `reports/all-jobs-hiring-status-report`, isShow: true, isAccess: _UAC_RPT?.report?.action?.read?.value },
        { name: 'Reports / Job wise interviews report', route: `reports/job-wise-interviews-report`, isShow: true, isAccess: __plan(PLAN.interview) && _UAC_RPT?.report?.action?.read?.value },
        { name: 'Reports / Archived Jobs Report', route: `reports/archived-jobs-report`, isShow: true, isAccess: _UAC_RPT?.report?.action?.read?.value },
        { name: 'Reports / Archive-UnArchive Candidate Report', route: `reports/archived-candidate-report`, isShow: true, isAccess: _UAC_RPT?.report?.action?.read?.value },
        { name: 'Reports / Active-Inactive Candidate Report', route: `reports/active-candidate-report`, isShow: true, isAccess: _UAC_RPT?.report?.action?.read?.value },
        { name: 'Reports / Download Request Report', route: `reports/download-request-report`, isShow: true, isAccess: _UAC_RPT?.downloadRequestReport?.action?.read?.value },
        { name: 'Reports / Import Summary Report', route: `reports/import-summary-report`, isShow: true, isAccess: _UAC_RPT?.importSummaryReport?.action?.read?.value },
        { name: 'Reports / Mail Status Report', route: `reports/mail-status-report`, isShow: true, isAccess: _UAC_RPT?.mailStatusReport?.action?.read?.value },
        { name: 'Reports / Time to Fill report', route: `reports/time-to-fill-report`, isShow: true, isAccess: true },
        { name: 'Reports / Employee Turnover Rate report', route: `reports/employee-turnover-rate-report`, isShow: true, isAccess: true },
        { name: 'Reports / Offer Acceptance Rate report', route: `reports/offer-acceptance-rate-report`, isShow: true, isAccess: true },
        { name: 'Reports / Fill Rate report', route: `reports/fill-rate-report`, isShow: true, isAccess: true },
        { name: 'Reports / Interview To Offer Ratio report', route: `reports/interview-to-offer-ratio-report`, isShow: true, isAccess: true },
        { name: 'Reports / Recruitment Pipeline Status report', route: `reports/recruitment-pipeline-status-report`, isShow: true, isAccess: true },
        { name: 'Reports / Rejected & Hold Candidates report', route: `reports/rejected-and-hold-candidates-report`, isShow: true, isAccess: true },
        { name: 'Reports / Opening vs Application vs Onboarding report', route: `reports/opening-vs-application-vs-onboarding-report`, isShow: true, isAccess: true },
        { name: 'Reports / Offer Released vs Offer Acceptance report', route: `reports/offer-released-vs-offer-acceptance-report`, isShow: true, isAccess: true },
        { name: 'Reports / Diversity Hiring report', route: `reports/diversity-hiring-report`, isShow: true, isAccess: true },
        { name: 'Reports / Job wise vs Status Wise vs Tag wise report', route: `reports/job-wise-vs-status-wise-vs-tag-wise-report`, isShow: true, isAccess: true },
        { name: 'Reports / Workforce Forecast vs Actual report', route: `reports/workforce-forecast-vs-actual-report`, isShow: true, isAccess: true },
        { name: 'Reports / Budget Forecast vs Actual Spend report', route: `reports/budget-forecast-vs-actual-spend-report`, isShow: true, isAccess: true },
        { name: 'Reports / Screening Efficiency report', route: `reports/screening-efficiency-report`, isShow: true, isAccess: true },
        { name: 'Reports / Source-wise Conversion Rate report', route: `reports/source-wise-conversion-rate-report`, isShow: true, isAccess: true },
        { name: 'Reports / Funnel of Job Opening Stages report', route: `reports/funnel-of-job-opening-stages-report`, isShow: true, isAccess: true },


        { name: 'release note', route: `release-note`, isAccess: true },
        { name: 'download app', route: `downloads`, isAccess: true },
        { name: 'notifications', route: `notifications`, isAccess: true },
    ]);

    const [matchedRoutes, setMatchedRoutes] = useState([]);
    const [searchText, setSearchText] = useState('');

    const _CAN_READ_JOB = _UAC_J?.jobs?.action?.read?.value;
    const _CAN_READ_CANDIDATE = _UAC_C?.candidates?.action?.read?.value;

    const defaultRoutes = () => allRoutes?.filter(route => route?.isShow && route?.isAccess);

    useEffect(() => {
        setMatchedRoutes(defaultRoutes());
    }, [allRoutes]);

    useHotKey('k', () => closeSidebar(true));

    useEffect(() => {
        refresh();
        if (_CAN_READ_CANDIDATE) {
            sendData('ats|candidate|search', {search: '', globalSearch: true});
        }
        if (_CAN_READ_JOB) {
            sendData('ats|job|search', {search: '', globalSearch: true});
        }
        return () => {
            off();
        };
    }, []);

    const {off, refresh} = useSocket(res => {
        if (!res.error && (res?.data?.socketId === _S_ID)) {
            switch (res.event) {
                case 'ats|candidate|search':
                    setCandidateListOption(res?.data?.list);
                    break;
                case 'ats|job|search':
                    setJobListOption(res?.data?.list);
                    break;
                default:
                    return true;
            }
        }
    });




    const handle = {
        // For menu - instant, on every keystroke
        search: (text) => {
            setSearchText(text);

            if (!text?.trim()) {
                setMatchedRoutes(defaultRoutes());
                return;
            }

            setMatchedRoutes(allRoutes?.filter(route => route?.isAccess && route?.name?.toLowerCase()?.includes(text.toLowerCase().trim())));
        },

        // For jobs / candidates - debounced, socket backed
        searchList: (text) => {
            if (text?.length !== 0 && text?.length < LIMIT.SEARCH_CHARACTER) return;

            //    for Candidates
            if (_CAN_READ_CANDIDATE) {
                sendData('ats|candidate|search', {search: text, globalSearch: true});
                refresh();
            }
            //    for Job
            if (_CAN_READ_JOB) {
                sendData('ats|job|search', {search: text, globalSearch: true});
                refresh();
            }
        },
    }

    const closeSearch = () => {
        closeSidebar(false);

        if (!searchText) return;

        setSearchText('');
        setMatchedRoutes(defaultRoutes());
        if (_CAN_READ_CANDIDATE) {
            sendData('ats|candidate|search', {search: '', globalSearch: true});
            refresh();
        }
        if (_CAN_READ_JOB) {
            sendData('ats|job|search', {search: '', globalSearch: true});
            refresh();
        }
    }

    const menuChange = (route) => {
        closeSearch();
        history.push(`/${_ORG_ID}/${route?.route}`);
    }

    const viewCandidates = (e) => {
        closeSearch();
        const name = Object.keys(P_DT).find(e => P_DT[e]) ?? 'details';
        history.push(`/${_ORG_ID}/candidates/details/${e}/${name}`);
    }

    const viewJob = (e) => {
        closeSearch();
        const name = Object.keys(P_JDT).find(e => P_JDT[e]) ?? 'summary';
        history.push(`/${_ORG_ID}/jobs/${e}/${name}`);
    }

    const seeMoreCandidates = () => {
        closeSearch();
        history.push(`/${_ORG_ID}/candidates/list`);
    }

    const seeMoreJob = () => {
        closeSearch();
        history.push(`/${_ORG_ID}/jobs`);
    }

    const placeholder = `Search for Menu${_CAN_READ_JOB ? ', Jobs' : ''}${_CAN_READ_CANDIDATE ? ' & Candidates' : ''}...`;

    const groups = [{
        key: 'menu',
        label: 'Menu',
        items: matchedRoutes,
        limit: 5,
        itemClassName: 'u_cmdp-item__capitalize',
        itemKey: (route, i) => `${route?.route || ''}-${i}`,
        renderItem: route => route?.name,
        onSelect: route => menuChange(route),
    }];

    if (_CAN_READ_JOB) {
        groups.push({
            key: 'job',
            label: 'Jobs',
            items: jobListOption,
            limit: 5,
            renderItem: job => job?.name,
            onSelect: job => viewJob(job?._id),
        });
    }

    if (_CAN_READ_CANDIDATE) {
        groups.push({
            key: 'candidate',
            label: 'Candidates',
            items: candidateListOption,
            limit: 5,
            renderItem: candidate => <UEmployeeInfo size={26} employee={candidate}/>,
            renderBadge: candidate => {
                const badges = [];

                if (candidate?.isQuicklyAdded) badges.push({key: 'quick', label: 'Q', title: 'Quick Added', variant: ''});
                if (candidate?.isRejected) badges.push({key: 'rejected', label: 'R', title: `Rejected: ${_DRL?.find(_ => _?.value === candidate?.disqualifyReason)?.name ?? '-'}`, variant: 'u_cmdp-badge__red'});
                if (candidate?.isDeleted) badges.push({key: 'inactive', label: 'Inactive', title: 'Inactive', variant: 'u_cmdp-badge__red'});
                if (candidate?.isSelected) badges.push({key: 'selected', label: 'S', title: 'Selected', variant: 'u_cmdp-badge__green'});
                if (candidate?.isNew) badges.push({key: 'new', label: 'New', title: 'New', variant: 'u_cmdp-badge__green'});

                if (!badges?.length) return null;

                return badges?.map((badge, i) => (
                    <span key={badge?.key} className={`u_cmdp-badge ${badge?.variant} ${i ? 'u_ml-5' : ''}`} title={badge?.title}>{badge?.label}</span>
                ));
            },
            onSelect: candidate => viewCandidates(candidate?._id),
        });
    }

    return (
        <React.Fragment>

            <div className="u_global-search">
                <UCommandPaletteTrigger placeholder={placeholder} onClick={() => closeSidebar(true)}/>
            </div>

            <UCommandPalette
                open={!!open}
                onClose={closeSearch}
                search={searchText}
                onSearch={text => handle.search(text)}
                onDebouncedSearch={text => handle.searchList(text)}
                groups={groups}
                placeholder={placeholder}
                footer={(_CAN_READ_JOB || _CAN_READ_CANDIDATE) && (
                    <div className="u_flex u_align-center">
                        {_CAN_READ_JOB && <span className="u_label u_color-blue u_cp" onClick={seeMoreJob}>See More Job</span>}
                        {_CAN_READ_CANDIDATE && <span className={`u_label u_color-blue u_cp ${_CAN_READ_JOB ? 'u_ml-15' : ''}`} onClick={seeMoreCandidates}>See More Candidates</span>}
                    </div>
                )}
            />

        </React.Fragment>
    )
}

export default GlobalSearch;
